"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@chakra-ui/react");
var Footer = function () {
    var date = new Date();
    return (react_1.default.createElement(react_2.Box, { backgroundColor: "#4e473c", padding: "1rem", width: "100%", as: "footer", display: "flex", alignItems: "center", justifyContent: "center", h: "4rem", position: "absolute", bottom: "0" },
        react_1.default.createElement(react_2.Text, { fontSize: { base: "0.8rem", md: "1.2rem" }, textAlign: "center", color: "#fff" }, "Copyright\u00A9 2021-" + date.getFullYear() + " JA Zen-Noh Hiroshima All rights reserved.")));
};
exports.Footer = Footer;
